/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_ValidationInputs */



/**
* | output |
* | --- |
* | "Please enter username and password" |
*
* @param {Work_Order_Publish_Auth_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_validation = /** @type {((inputs?: Work_Order_Publish_Auth_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez saisir le nom d’utilisateur et le mot de passe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie Benutzernamen und Passwort ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci nome utente e password")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, введите имя пользователя и пароль.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, introduzca su nombre de usuario y contraseña")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入用户名和密码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザー名とパスワードを入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया उपयोगकर्ता नाम और पासवर्ड दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira o nome de usuário e a senha.")
	return /** @type {LocalizedString} */ ("Please enter username and password")
});